<template>
  <div class="content">
    <div class="bg signup-view" v-bind:style="{ 'background-image': 'url(' + pics.bg_user_login + ')' }">
      <h3>新用户注册</h3>
      <div class="signup-box">
        <div class="signup-form">
          <van-field v-model="phone" type="tel" placeholder="请输入手机号码" icon-prefix="phone" class="form-filed" />
          <van-field v-model="sms" center clearable placeholder="请输入短信验证码" class="form-filed">
            <template #button>
              <van-button size="small" type="info" @click="sendCode()" v-if="!isSending">发送验证码</van-button>
              <van-button size="small" type="info" :disabled="true" v-else>已发送（{{countDown}}）</van-button>
            </template>
          </van-field>
          <div class="field-border"></div>
        </div>
        <div class="signup-footer">
          <van-button type="info" size="large" :disabled="signUpBtnDisable" @click="signupProfile()">注册</van-button>
          <router-link to="/login" tag="span" class="login-link">已有账号登录</router-link>
        </div>
      </div>
    </div>

    <div class="captcha-wrap">
      <van-overlay :show="captchaDialogVisible">
        <captcha-dialog v-if="captchaDialogVisible" @change="sendSmsCodeWithCaptcha"
          @cancel="captchaDialogVisible=false" />
      </van-overlay>
    </div>
  </div>
</template>

<style lang="less" scoped>
  body {
    background: #fff;
  }

  .content {
    height: 100vh;
    overflow: hidden;
    background: #fff;

    .bg {
      background: url("../../assets/images/bg-login.png") no-repeat top center;
      background-size: 100% auto;
    }

    .signup-view {
      padding-top: 20vh;
      padding-left: 20px;
      padding-right: 20px;
    }

    .profile-view {
      padding-top: 20vh;
      padding-left: 20px;
      padding-right: 20px;
    }

    h3 {
      font-size: 22px;
      text-align: center;
    }
  }

  .signup-box {
    background: #fff;
    text-align: center;

    /deep/.van-tab {
      font-size: 18px;
    }

    .signup-form {
      padding: 20px;

      .form-filed {
        margin-bottom: 24px;
        font-size: 16px;
        height: 50px;
      }

      .field-border ::after {
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }

    .signup-footer {
      padding: 0 20px;

      .login-link {
        display: block;
        margin: 20px 0;
        color: var(--color-main);
        font-size: 16px;
      }
    }
  }
</style>

<script>
  import {
    checkPhoneNumber
  } from "@/libs/validate-utils";
  import {
    pics
  } from '@/libs/common'
  import * as api_user from '@/api/user';

  import {
    mapActions,
    mapState
  } from 'vuex'
  import captchaDialog from '../../components/captchaDialog.vue';
  export default {
    components: {
      captchaDialog
    },
    data() {
      return {
        phone: "",
        sms: "",
        isSending: false,
        countDown: 90,
        timer: undefined,
        pics,
        captchaDialogVisible: false, //显示图片验证码窗口
      };
    },
    computed: {
      ...mapState({
        openId: state => state.user.openId,
        configs: state => state.hospital.configs
      }),
      signUpBtnDisable() {
        return (!this.sms || this.sms.length < 4)
      },
      //是否启用图形验证码
      enableCaptcha() {
        if (this.configs && this.configs.length > 0) {
          var cfg = this.configs.find(it => it.code == 'enable_captcha');
          if (cfg && cfg.value == '是')
            return true;
        }
        return false;
      },
    },
    methods: {
      ...mapActions("user", {
        signUpPhone: "signUpPhone"
      }),
      sendCode() {
        if (!checkPhoneNumber(this.phone)) {
          this.$Toast("手机号不正确，请重新输入");
          return;
        }
        if (this.enableCaptcha) {
          this.captchaDialogVisible = true;
          return;
        }
        let hospId = this.$route.query.hospid;
        api_user.sendSmsCode(hospId, this.phone).then(resp => {
          console.log(resp);
        })

        this.isSending = true;
        this.countDown = 90;
        if (!this.timer) {
          let _this = this;
          this.timer = setInterval(() => {
            if (_this.countDown <= 0) {
              _this.isSending = false;
            } else {
              _this.countDown--;
            }
          }, 1000);
        }
      },
      //发送短信验证码（需要进行图片验证）
      sendSmsCodeWithCaptcha(captcha) {
        let _this = this;
        let hospId = this.$route.query.hospid;
        _this.captchaDialogVisible = false;
        api_user.sendSmsVerificationCode(hospId, this.phone, captcha.key, captcha.value).then(res => {
          if (res.code != 200) {
            _this.$Toast.fail(res.msg, 5000);
          } else {
            // 已发送，待用户输入短信码
            _this.isSending = true;
            _this.countDown = 90;
            if (!_this.timer) {
              _this.timer = setInterval(() => {
                if (_this.countDown <= 0) {
                  _this.isSending = false;
                } else {
                  _this.countDown--;
                }
              }, 1000);
            }
          }
        })
      },
      signupProfile() {
        if (!this.sms || this.sms == '') {
          this.$toast('请输入短信验证码');
          return;
        }
        //输入
        api_user.checkSmsCode(this.phone, this.sms).then(res => {
          if (res.code == 200) {
            this.signUpPhone(this.phone);
            this.$router.push({
              path: "/signup_profile",
              query: {
                sign: res.data
              }
            });
          } else {
            this.$toast(res.msg);
            return;
          }
        })
      }
    },
    mounted() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = undefined;
      } else {

      }
    },

  };
</script>